import { Link } from "react-router-dom";
import { marketsContent } from "../content/markets.js";

export default function MarketsPage() {
  return (
    <article className="site-page markets-page">
      <div className="site-page__inner site-page__inner--wide markets-page__inner">
        <header className="markets-hero">
          <div>
            <p className="site-page__eyebrow">Markets</p>
            <h1 className="site-page__title">
              Industries &amp; Southern California geography
            </h1>
            <p className="site-page__lead">{marketsContent.intro}</p>
          </div>
          <p className="site-page__note markets-hero__note">
            {marketsContent.disclaimer}
          </p>
        </header>

        <section className="site-section">
          <h2>Sectors</h2>
          <div className="markets-sector-list">
            {marketsContent.industries.map((ind) => (
              <article key={ind.id} className="markets-sector">
                <h3>{ind.name}</h3>
                <p className="markets-sector__segments">{ind.segments}</p>
                <ul className="site-page__list">
                  {ind.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
                {ind.caveat ? (
                  <p className="markets-sector__caveat">{ind.caveat}</p>
                ) : null}
              </article>
            ))}
          </div>
        </section>

        <section className="site-section">
          <h2>Geographic focus</h2>
          <div className="markets-region-list">
            {marketsContent.geography.map((g) => (
              <article key={g.slug} className="markets-region">
                <strong>{g.region}</strong>
                <p>{g.note}</p>
              </article>
            ))}
          </div>
        </section>

        <p className="site-page__cta">
          <Link to="/pricing" className="site-button-primary">
            Review pricing frameworks
          </Link>
          <Link to="/" className="site-button-ghost">
            ← Back to home
          </Link>
        </p>
      </div>
    </article>
  );
}
